import React from "react";
import "../../../styles/admin/initialTest.scss";

const InitialTestCard = ({ test, onClick }) => {
  if (!test) return null;

  const handleClick = () => {
    if (onClick) {
      onClick(test);
    }
  };

  const createdAt = test.created_at ? new Date(test.created_at) : null;
  const formattedDate =
    createdAt && !isNaN(createdAt.getTime())
      ? createdAt.toLocaleDateString()
      : null;

  return (
    <div className="initial-test-card" onClick={handleClick}>
      <div className="initial-test-card__body">
        <h3 className="initial-test-card__title">
          {test.name || "Untitled Test"}
        </h3>
        {test.course_name && (
          <div className="initial-test-card__meta">
            Course: {test.course_name}
          </div>
        )}
        {formattedDate && (
          <div className="initial-test-card__meta">
            Created: {formattedDate}
          </div>
        )}
      </div>
    </div>
  );
};

export default InitialTestCard;
